<template>
    <v-container>
        <v-layout row>
            <v-flex xs12 sm12>
                <v-card class="mt-6" v-if="item">
                    <v-carousel
                            cycle
                            hide-delimiter-background
                            show-arrows
                            height="350"
                    >
                        <v-carousel-item
                                v-for="img in item.imgs"
                                :key="img.id"
                        >
                            <v-img
                                    :src="img.url"
                                    height="350px"
                                    contain
                                    @click="imageSelected(img.id)"
                            ></v-img>
                        </v-carousel-item>
                    </v-carousel>
                  <v-card-text>
                    <v-btn block outlined class="success--text mb-2" @click="openImgUploadDialog">
                      <v-icon>photo</v-icon>
                      Upload Image</v-btn>
                    <v-row class="mt-6">

                    </v-row>
                    <!--title  -->
                    <v-card-title>
                      <v-text-field
                          color="blue"
                          v-model="item.title"
                          class="headline"
                          label="Name"
                      ></v-text-field>
                      <v-spacer></v-spacer>
                      <!--Listed unlisted-->
                      <v-switch
                          color="blue"
                          v-model="item.listed"
                          label="Listed"
                      ></v-switch>
                    </v-card-title>
                    <v-card-title class="font-weight-light text-h6">
                      Type: {{item.itemType}}
                      <v-spacer></v-spacer>
                      <v-btn @click="productSettingsDialog = true"
                             class="align-right"
                             text
                             outlined small rounded>
                        <v-icon>settings</v-icon>
                        Settings</v-btn>
                    </v-card-title>
                    <v-divider class="mb-3"></v-divider>
                    <v-expansion-panels multiple v-if="item">
                      <!--                          base rate and additional costs-->
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          <div class="black--text font-weight-regular text-h6">
                            <v-icon>attach_money</v-icon>
                            Price: {{item.baseRate}}</div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content  v-if="item">
                          <!--                            base rate-->
                          <v-col
                              class="d-flex"
                              cols="12"
                              sm="12"
                          >

                            <v-text-field
                                color="blue"
                                v-model="item.baseRate"
                                label="Base rate"
                                prepend-inner-icon="attach_money"
                                type="number"
                            ></v-text-field>
                            <!--                            cost per additional unit-->
                            <v-text-field
                                color="blue"
                                v-model="item.costPerAdditionalUnit"
                                label="Cost per additional unit"
                                prepend-inner-icon="attach_money"
                                type="number"
                            ></v-text-field>
                          </v-col>
                          <!--                            if service included hours-->
                          <v-col
                              class="d-flex"
                              cols="12"
                              sm="12"
                          >
                            <!--                            if service included hours-->
                            <v-text-field
                                color="blue"
                                v-model="item.includedHours"
                                label="Hours included"
                                prepend-inner-icon="timer"
                                type="number"
                            ></v-text-field>
                            <!--                            if service additional time factor-->
                            <v-text-field
                                color="blue"
                                v-model="item.finalCostMultiplier"
                                label="Cost multiplier"
                                prepend-inner-icon="calculate"
                                type="number"
                            ></v-text-field>
                          </v-col>
                          <!--                            additional costs-->
                          <v-col>
                          <div class="mt-4">Additional cost</div>
                            <v-simple-table v-if=" item.additionalCost.length > 0">
                              <template v-slot:default>
                                <thead>
                                <tr>
                                  <th class="text-left">
                                    Name
                                  </th>
                                  <th class="text-left">
                                    Cost ($/qtyUnit)
                                  </th>
                                  <th class="text-left">
                                  </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr
                                    v-for="cost in item.additionalCost"
                                    :key="cost.id"
                                >
                                  <td>{{ cost.title }}</td>
                                  <td>{{ cost.cost }}<span v-if="cost.qtyUnit !== ''">/{{cost.qtyUnit}}</span></td>
                                  <td class="text-right">
                                    <v-icon @click="removeAdditionalCost(cost)"
                                            class="red--text">close</v-icon>
                                  </td>
                                </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                            <v-btn class="mt-3" outlined @click="addMoreCostDialog = true">
                              <v-icon>add</v-icon>
                              Add more cost
                            </v-btn>
                          </v-col>
                          <!--                            if service addOnItems-->
                          <div class="mt-4" v-if="item.itemType === 'service'">Included Items</div>
                          <!--                            if service addOnItems-->
                          <v-col class="mt-2" v-if="item.itemType === 'service'">
                            <!--                            if service addOnItems-->
                            <v-simple-table fixed-header>
                              <template v-slot:default>
                                <tbody v-for="item in item.addOnItems"
                                       :key="item.id">
                                <tr>
                                  <td>{{item.qty}} x</td>
                                  <td @click="modifyAddOnItem(item)">
                                    {{item.title}}
                                  </td>
                                  <td class="text-right">
                                    <!--remove addOn Item-->
                                    <v-btn icon @click="removeAddOnItem(item.id)">
                                      <v-icon class="red--text">clear</v-icon>
                                    </v-btn>
                                  </td>
                                </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                            <addon-item-picker
                                v-if="user"
                                :publicListingId="user.publicListingId"
                                :listingId="listingId"
                                @itemFound="addOnItemPicked"
                            ></addon-item-picker>
                          </v-col>
                          <!--                            additional fees label-->
                          <v-col class="mt-2" v-if="item.itemType === 'product' && item.deliveryEnabled">
                            <v-text-field
                                color="blue"
                                v-model="item.additionalFeesLabel"
                                label="Additional Fees Label"
                                placeholder="ie. 'shipping fee' or 'delivery fee'"
                                prepend-inner-icon="label"
                            ></v-text-field>
                          </v-col>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
<!--                  Fulfillment options-->
                      <v-expansion-panel v-if="!item.onlineOnly">
                        <v-expansion-panel-header>
                          <div class="black--text font-weight-regular text-h6"
                          ><v-icon>local_shipping</v-icon>Fulfillment options</div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <div v-if="!item.pickupLocationEnabled" class="pt-3 pb-2 font-weight-regular">
                            Add starting location</div>
                          <div v-else class="pt-3 pb-2 font-weight-regular">
                            <v-icon>map</v-icon>
                            Add pickup or starting location
                          </div>
                          <v-divider></v-divider>
                          <div class="subtitle-2 mt-3 ml-2 font-weight-regular" v-for="location in item.startingLocations" :key="location.created">
                            <v-icon>pin_drop</v-icon>
                            {{locationCountryRemoved(location.formatted_address)}}
                            <v-icon @click="removeStartingLocation(location)"
                                    class="red--text">close</v-icon>
                          </div>
<!--                          starting or pickup locations-->
                          <v-col
                              class="d-flex"
                              cols="12"
                              sm="12"
                              v-if="item"
                          >
                            <v-flex xs10 sm12 md12 v-if="(item.startingLocations.length < 1) || (item.additionalLocationsEnabled)">
                              <locations-autocomplete  @locationFound="addStartingLocations"></locations-autocomplete>
                            </v-flex>
                          </v-col>

                          <div class="mt-4">
                            Distance fees
                          </div>
                          <v-divider></v-divider>
                          <v-col
                              class="d-flex"
                              cols="12"
                              sm="12"
                              v-if="item"
                          >
                            <!--additional km rate-->
                            <v-text-field
                                color="blue"
                                v-model="item.additionalKmRate"
                                label="Additional Kilometer Cost"
                                placeholder="2.50"
                                prepend-inner-icon="attach_money"
                                type="number"
                            ></v-text-field>
                          </v-col>
                          <!--                            address label-->
                          <v-col
                              class="d-flex"
                              cols="12"
                              sm="12"
                              v-if="item"
                          >
                            <v-text-field
                                color="blue"
                                v-model="item.locationLabel"
                                label="Address Label"
                                placeholder="Ex. Destination, location, service address"
                                prepend-inner-icon="label"
                            ></v-text-field>
                          </v-col>
                          <!--if service included kms-->
                          <v-col
                              class="d-flex"
                              cols="12"
                              sm="12"
                              v-if="item">
                            <v-text-field
                                color="blue"
                                v-model="item.includedKm"
                                label="Kilometers included"
                                placeholder="100"
                                prepend-inner-icon="add_road"
                                type="number"
                            ></v-text-field>
                          </v-col>
                          <!--available on demand-->
                          <div class="mt-4">
                            Self checkout
                          </div>
                          <v-divider></v-divider>
                          <v-col
                              class="d-flex"
                              cols="12"
                              sm="12"
                              v-if="item">
                            <v-icon>shopping_cart_checkout</v-icon>
                            <v-checkbox
                                color="blue"
                                v-model="item.availableOnDemand"
                                label="Available on Demand"
                            ></v-checkbox>
                          </v-col>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
<!--                    item description-->
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          <div class=" black--text font-weight-regular text-h6">
                            <v-icon>description</v-icon>
                            Descriptions</div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
<!--                          short description-->
                          <v-col
                              class="d-flex"
                              cols="12"
                              sm="12"
                              v-if="item"
                          >
                            <v-textarea
                                rows="3"
                                color="blue"
                                outlined
                                label="Short description"
                                v-model="item.shortDescription"
                            ></v-textarea>
                          </v-col>
                          <!--features list -->
                          <v-col
                              cols="12"
                              sm="12"
                              v-if="item"
                          >
                            <div>List of features</div>
                            <v-divider></v-divider>
                            <v-simple-table class="mt-2 mb-2">
                              <template v-slot:default>
                                <tbody>
                                <tr
                                    v-for="feature in item.featuresList"
                                    :key="feature.id"
                                >
                                  <td @click="newFeature = feature.text">{{ feature.text }}</td>
                                  <td class="text-right">
                                    <v-icon @click="removeFeature(feature.id)"
                                            class="red--text">close</v-icon>
                                  </td>
                                </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                            <v-text-field
                                color="blue"
                                v-model="newFeature"
                                outlined
                                label="Add a feature"
                                placeholder="Easy online booking.."
                                append-outer-icon="check"
                                @click:append-outer="addNewFeature"
                            ></v-text-field>
                          </v-col>
                          <!--featured images -->
                          <v-col
                              cols="12"
                              sm="12"
                              v-if="item"
                          >
                            <div v-for="img in item.featuredImgs" :key="img.id">
                              <v-img
                                  contain
                                  :src="img.url"
                                  aspect-ratio="1.7"
                                  @click="openFeaturedImage(img.id)"
                              ></v-img>
                            </div>
                              <v-btn
                                  block
                                  outlined
                                  class="success--text mb-2 mt-2"
                                  @click="featuredImageUploadDialog = true">
                                <v-icon>photo</v-icon>
                                Add image
                              </v-btn>
                          </v-col>
                          <!--full description -->
                          <v-col
                              class="d-flex"
                              cols="12"
                              sm="12"
                              v-if="item"
                          >
                            <v-textarea
                                color="blue"
                                outlined
                                label="Full description"
                                v-model="item.fullDescription"
                            ></v-textarea>
                          </v-col>
                          <!--instruction-->
                          <v-col
                              class="d-flex"
                              cols="12"
                              sm="12"
                              v-if="item"
                          >
                            <v-text-field
                                v-model="item.instruction"
                                color="blue"
                                outlined
                                label="Instruction"
                                placeholder="Instruction for service providers"
                                append-outer-icon="check"
                                @click:append-outer="addNewFeature"
                            ></v-text-field>
                          </v-col>

                          <!--note-->
                          <v-col
                              class="d-flex"
                              cols="12"
                              sm="12"
                              v-if="item"
                          >
                            <v-text-field
                                v-model="item.note"
                                color="blue"
                                outlined
                                label="Note"
                                placeholder="This is visible on invoice"
                                append-outer-icon="check"
                                @click:append-outer="addNewFeature"
                            ></v-text-field>
                          </v-col>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-card-text>
<!--                  input field errors-->
                  <v-card-text v-if="item">
                    <div v-if="item.itemType === 'product'">
                      <div v-if="item.pickupLocationEnabled && item.startingLocations.length < 1"
                           class="red--text">*Missing pickup location</div>
                      <div v-if="item.deliveryEnabled && item.startingLocations.length < 1"
                           class="red--text">*Missing starting location</div>
                      <div v-if="!item.onlineOnly && item.locationLabel === ''"
                           class="red--text">*Missing Address Label</div>
                      <div  v-if="item.deliveryEnabled && item.additionalFeesLabel === ''"
                            class="red--text">*Missing Additional fees label</div>
                    </div>
                    <div v-if="item.itemType === 'service'">
                      <div v-if="item.calcTravelTime && item.startingLocations.length < 1"
                           class="red--text">*Missing starting location
                      </div>
                      <div v-if="item.startingLocations.length < 1"
                           class="red--text">*Missing starting location
                      </div>
                      <div v-if="item.locationLabel === ''"
                           class="red--text">*Missing Address Label
                      </div>
                    </div>

                  </v-card-text>

                  <v-card-actions>
                    <v-btn block class="outlined blue--text mb-3" dark @click="copyItemDialog = true" outlined>Copy or add variation</v-btn>
                  </v-card-actions>
                  <v-card-actions>
                    <v-btn block class="blue white--text mb-3" @click="updateItem" outlined>Update</v-btn>
                  </v-card-actions>
                </v-card>

                <v-btn text block router :to="'/listing/' + listingId">
                  <v-icon>keyboard_arrow_left</v-icon>
                  back to Listing
                </v-btn>

                <v-btn v-if="item" block text outlined class="mt-12 red--text" @click="deleteDialog = true">delete</v-btn>
            </v-flex>
          <v-dialog v-model="selectedAddOnItemDialog"
                    persistent
                    max-width="500"
          >
            <v-card v-if="selectedAddOnItem">
              <v-card-title class="text-h5">
                {{selectedAddOnItem.title}}
              </v-card-title>

              <v-card-text>
                <v-card-actions>
                  <v-btn block outlined @click="selectedAddOnItem.qty++">
                    <v-icon>add</v-icon></v-btn>
                </v-card-actions>
                <v-container fluid fill-height>
                  <v-layout align-center justify-center>
                    <v-flex xs3 sm3 md3 lg3>
                      <v-text-field
                          v-model="selectedAddOnItem.qty"
                          color="blue"
                          label="Quantity"
                          type="number"
                          dense
                          solo
                          placeholder="1"
                          min="1"
                          max="100"
                          class="display-1"
                          height="60px"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
                <v-card-actions>
                  <v-btn block
                         outlined
                         :disabled="selectedAddOnItem.qty <= 1"
                         @click="selectedAddOnItem.qty--">
                    <v-icon>remove</v-icon></v-btn>
                </v-card-actions>
                <!--          add-on item name-->
                <v-text-field
                    label="Name"
                    v-model="selectedAddOnItem.title"
                ></v-text-field>
                <!--          add-on item details-->
                <v-text-field
                    label="Time required in minutes"
                    placeholder="30"
                    type="number"
                    v-model="selectedAddOnItem.timeFactor"
                ></v-text-field>
                <v-slider
                    v-model="selectedAddOnItem.travelFactor"
                    label="Travel factor"
                    thumb-color="blue"
                    thumb-label="always"
                    min="1"
                    max="5"
                ></v-slider>
                <v-switch
                    v-if="selectedAddOnItem.customAddOnItem"
                    color="blue"
                    v-model="selectedAddOnItem.customAddOnItem"
                    label="Custom item"
                ></v-switch>
                <v-card-actions class="mt-10">
                  <v-spacer></v-spacer>
                  <v-btn
                      text
                      @click="selectedAddOnItemDialog = false"
                  >close</v-btn>
                  <v-btn
                      color="blue"
                      outlined
                      @click="updateAddOnItem"
                  >
                    ok
                  </v-btn>
                </v-card-actions>
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-dialog v-model="imageDialog"
                    width="500px"
            >
                <v-card>
                  <v-img
                      v-if="pickedImage"
                      :src="pickedImage.url"
                      contain
                      height="500px"
                  >
                  </v-img>
                  <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn outlined @click="deleteImage" class="red white--text">delete</v-btn>
                        <v-btn @click="imageDialog = false">close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
          <v-dialog v-model="deleteDialog"
                    ref="dialog"
                    persistent
                    width="300px"
          >
            <v-card v-if="item">
              <v-card-title>
                <div class="white black--text text-xs-center font-weight-thin subtitle-1">
                  {{item.title}} will be deleted forever.</div>
              </v-card-title>
              <v-card-text v-if="(item.imgs.length > 0) || (item.featuredImgs.length > 0)">
               Delete all images from carousel an description before deleting
              </v-card-text>
              <v-card-text class="display-1" v-else>
                Delete Item?
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="deleteDialog = false" text>cancel</v-btn>
                <v-btn
                    @click="deleteItem()"
                    :disabled="(item.imgs.length > 0) || (item.featuredImgs.length > 0)"
                    dark
                    class="error">delete</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="imageUploadDialog"
                    ref="dialog"
                    persistent
                    width="500px"
          >
            <v-card>
              <v-card-title>Select image to upload</v-card-title>
              <gen-img-uploader path="inventoryContent" @imageLinkFound="addImageLink" @removeImage="removeImageLink"></gen-img-uploader>
              <v-card-text v-if="mediaUrl">
                <v-img contain :src="mediaUrl" aspect-ratio="1.7"></v-img>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text :disabled="!mediaUrl" @click="uploadImgToItem">ok</v-btn>
                <v-btn text @click="cancelImageUpload">cancel</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="addMoreCostDialog"
                    ref="dialog"
                    persistent
                    width="500px"
          >
            <v-card>
              <v-card-title>Additional fee details</v-card-title>
              <v-card-text v-if="additionalCostObj">
                <v-col
                    class="d-flex"
                    cols="12"
                    sm="12"
                >
                  <!--                           title-->
                  <v-text-field
                      color="blue"
                      v-model="additionalCostObj.title"
                      label="Fee Label"
                      placeholder="ex..Truck fee"
                      prepend-inner-icon="label"
                  ></v-text-field>
                  <!--                            cost-->
                  <v-text-field
                      color="blue"
                      v-model="additionalCostObj.cost"
                      label="Cost"
                      placeholder="100.00"
                      prepend-inner-icon="attach_money"
                      type="number"
                  ></v-text-field>
                </v-col>
                <v-col
                    class="d-flex"
                    cols="6"
                    sm="6"
                >
                  <!--                            qtyUnit-->
                  <v-text-field
                      color="blue"
                      v-model="additionalCostObj.qtyUnit"
                      label="Quantity unit"
                      placeholder=" km, Hr, litre, case"
                      prepend-inner-icon="label"
                  ></v-text-field>
                </v-col>
                <v-col
                    class="d-flex"
                    cols="12"
                    sm="12"
                >
                  <!--                            note-->
                  <v-textarea
                      color="blue"
                      v-model="additionalCostObj.note"
                      label="Note"
                      placeholder="This is visible on invoice memo"
                      prepend-inner-icon="label"
                  ></v-textarea>
                </v-col>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="blue--text" text outlined :disabled="additionalCostObj.title === '' || additionalCostObj.cost === 0"
                       @click="addMoreCost">
                  Add cost</v-btn>
                <v-btn text @click="addMoreCostDialog = false">cancel</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="productSettingsDialog"
                    ref="dialog"
                    persistent
                    width="500px"
          >
            <v-card v-if="item">
              <v-card-title>
                <div v-if="item.itemType === 'service'" class="font-weight-regular text-h6">
                  <v-icon>settings</v-icon>
                  Service settings</div>
                <div v-if="item.itemType === 'product'" class="font-weight-regular text-h6">
                  <v-icon>settings</v-icon>
                  Product settings</div>
              </v-card-title>
              <v-card-text >
                <v-col
                    cols="12"
                >
                  <v-select
                      :items="itemTypes"
                      label="Item type"
                      v-model="item.itemType"
                      outlined
                  ></v-select>
                  <div v-if="item.itemType === 'product'">
                    <div v-if="!item.onlineOnly">Fulfillment Options</div>
                    <div class="subtitle-1">{{fulfillmentMethod}}</div>
                    <v-checkbox
                        v-if="!item.onlineOnly"
                        color="blue"
                        v-model="item.deliveryEnabled"
                        label="Delivery allowed"
                    ></v-checkbox>
                    <v-checkbox
                        class="ml-3"
                        v-if="!item.onlineOnly && item.deliveryEnabled"
                        color="blue"
                        v-model="item.additionalLocationsEnabled"
                        label="Allow multiple locations"
                    ></v-checkbox>
                    <v-checkbox
                        v-if="!item.onlineOnly"
                        color="blue"
                        v-model="item.pickupLocationEnabled"
                        label="Pick up allowed"
                    ></v-checkbox>
                    <v-checkbox
                        color="blue"
                        v-model="item.onlineOnly"
                        label="Online only"
                    ></v-checkbox>
                  </div>
                  <div v-if="item.itemType === 'service'">
                    <div>Fulfillment Options:</div>
                    <v-divider></v-divider>
                    <div class="subtitle-1 font-weight-bold mt-2">{{fulfillmentMethod}}</div>
                    <v-checkbox
                        color="blue"
                        v-model="item.calcTravelTime"
                        label="Include travel time"
                    ></v-checkbox>
                    <v-checkbox
                        color="blue"
                        v-model="item.additionalLocationsEnabled"
                        label="Allow multiple locations"
                    ></v-checkbox>
                  </div>
                </v-col>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="blue--text" text outlined
                       @click="updateItem">
                  Save</v-btn>
                <v-btn text @click="productSettingsDialog = false">cancel</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="featuredImageUploadDialog"
                    ref="dialog"
                    persistent
                    width="500px"
          >
            <v-card>
              <v-card-title>Select image to upload</v-card-title>
              <gen-img-uploader path="inventoryContent" @imageLinkFound="addImageLink" @removeImage="removeImageLink"></gen-img-uploader>
              <v-card-text v-if="mediaUrl">
                <v-img contain :src="mediaUrl" aspect-ratio="1.7"></v-img>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text :disabled="!mediaUrl" @click="addFeaturedImg">ok</v-btn>
                <v-btn text @click="cancelImageUpload">cancel</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="copyItemDialog"
                    ref="dialog"
                    persistent
                    width="500px"
          >
            <v-card>
              <v-card-title>Create a duplicate</v-card-title>
              <v-card-text v-if="item">
                <v-col
                    class="d-flex"
                    cols="12"
                    sm="12"
                >
                  <!--    title-->
                  <v-text-field
                      color="blue"
                      v-model="duplicateItemName"
                      label="Item Name"
                      placeholder="Old Name - Blue"
                      prepend-inner-icon="label"
                  ></v-text-field>
                </v-col>
                <v-col
                    class="d-flex"
                    cols="12"
                    sm="12"
                >
                  <v-checkbox
                      v-if="item"
                      color="blue"
                      v-model="createItemVariation"
                      label="Create a variation of same item "
                  ></v-checkbox>
                </v-col>

              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="copyItemDialog = false">cancel</v-btn>
                <v-btn class="blue" dark :disabled="duplicateItemName === ''"
                       @click="copyItem">
                  create</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
    </v-container>
</template>
<script>
import {getDoc, setDoc, deleteDoc, updateDoc, doc, onSnapshot, collection, addDoc} from "firebase/firestore";
import {deleteObject, getStorage, ref} from "firebase/storage";
import {v1 as uuidv1, v4 as uuid} from "uuid"
    export default {
      props: ['listingId', 'itemId'],
      data () {
        return {
          item: undefined,
          itemTypes: ['service', 'product'],
          itemType: null,
          imageDialog: false,
          pickedImage: undefined,
          deleteDialog: false,
          imageUploadDialog: false,
          mediaUrl: undefined,
          imgId: '',
          addMoreCostDialog: false,
          additionalCostObj: {
            title: '',
            qtyUnit: '',
            qty: 1,
            cost: 0,
            note: ''
          },
          selectedAddOnItem: null,
          selectedAddOnItemDialog: false,
          productSettingsDialog: false,
          totalEstimate: 0,
          newFeature: '',
          featuredImageUploadDialog: false,
          selectedImageType: null,
          copyItemDialog: false,
          duplicateItemName: '',
          createItemVariation: false
        }
      },
      computed: {
        user () {
          return this.$store.getters.user
        },
        fulfillmentMethod () {
          let itemCategory = ''
          if (this.item.itemType === 'product') {
            if (this.item.deliveryEnabled) {
              itemCategory = 'Delivery only'
              if (this.item.additionalLocationsEnabled) {
                itemCategory = 'Delivery with multiple stops'
              }
            }
            if (this.item.pickupLocationEnabled) {
              itemCategory = 'Pick up Only'
            }
            if (this.item.pickupLocationEnabled
                && this.item.deliveryEnabled) {
              itemCategory = 'Pick up and Delivery available'

            }
            if (this.item.onlineOnly) {
              itemCategory = 'Available online only'
            }
          }
          if (this.item.itemType === 'service') {
            if (this.item.calcTravelTime) {
              itemCategory = 'Includes cost of travel'
              if (this.item.additionalLocationsEnabled) {
                itemCategory = 'Includes travel cost with multiple stops'
              }
            }
            if (this.item.additionalLocationsEnabled) {
              itemCategory = 'Multiple locations enabled'
              if (this.item.calcTravelTime) {
                itemCategory = 'Includes travel cost with multiple stops'
              }
            }
          }
          return itemCategory
        },
      },
      watch: {
        // itemType (value) {
        //   if (value === 'Service') {this.item.type = 'service'}
        //   if (value === 'Product') {this.item.type = 'product'}
        //   this.updateItem()
        // }
      },
      created() {
        // console.log()
        let db = this.$store.state.db
        let itemRef = doc(db, 'users', this.user.uid + '/listings/' + this.listingId + '/items/' + this.itemId)
        onSnapshot(itemRef, res => {
          if(res.exists) {
            let data = res.data()
            let item = {...data}
            console.log(item)
            this.item = item
            this.duplicateItemName = item.title + ' - COPY'
            // this.reCalculateSelectedLineItem()
          }
        })
      },
      methods: {
        copyItem () {
          if (this.createItemVariation) {
            if (!this.item.variationId) {
              this.item.variationId = uuidv1()
              this.updateItem()
              return this.setNewItem()
            }
            else {
              return this.setNewItem()
            }
          } else {
            return this.setNewItem()
          }
        },
        setNewItem () {
          let newItem
          // console.log(newItem)
          let db = this.$store.state.db
          let itemsRef = collection(db, 'users', this.user.uid + '/listings/' + this.listingId +'/items')
          newItem = {...this.item}
          newItem.title = this.duplicateItemName
          newItem.imgs = []
          newItem.featuredImgs = []
          newItem.listed = false
          if (!this.createItemVariation && newItem.variationId) {
            delete newItem.variationId
          }
          return addDoc(itemsRef, newItem)
              .then(res => {
                let itemRef = doc(db, 'users', this.user.uid + '/listings/' + this.listingId + '/items/' + res.id)
                this.copyItemDialog = false
                newItem.id = res.id
                return updateDoc(itemRef, newItem)
              })
              .then (()=> {
                return this.$router.push('/listing/' + this.listingId)
              })
              .catch(err => {
                this.$store.dispatch('setError', err)
              })
        },
        removeFeature (featureId) {
          // console.log(addOnItemId)
          let index = this.item.featuresList.findIndex(feat => {
            return feat.id === featureId
          })
          this.item.featuresList.splice(index, 1)
          this.updateItem()
        },
        addNewFeature () {
          if (this.newFeature !== '') {
            let newFeature = {
              text: this.newFeature,
              id: uuidv1(),
              created: Date.now()
            }
            this.item.featuresList.push(newFeature)
            this.newFeature = ''
          }
        },
        addStartingLocations (location) {
          // console.log(location)
          this.item.startingLocations.push(location)
          this.updateItem()
        },
        removeStartingLocation (location) {
          let index = this.item.startingLocations.findIndex(local => {
            return local.created === location.created
          })
          this.item.startingLocations.splice(index, 1)
          // console.log(this.item)
          this.updateItem()
        },
        locationCountryRemoved (location) {
          // console.log(location)
          // let formattedLocation = location
          let formattedLocation = location.match(/^(?:[^,]*,){2}([^,]*)/)[0]
          return formattedLocation
        },
        reCalculateSelectedLineItem () {
          // console.log(this.selectedItem)
          let total = 0
          let totalHours = 0
          let totalKm = 0
          let item = this.item
          let lineItems = []
          let totalTravelHours = 0
          item.cost = item.baseRate
          if(item.itemType === 'service') {
            // console.log('service')
            total = item.baseRate
            // addon items time factor
            let additionalTimelLineItem = {
              title: 'Additional Time',
              created: Date.now(),
              cost: 0,
              qty: 0,
              qtyUnit: 'hour',
              id: uuidv1()
            }
            let addOnItemTime = 0
            if (this.item.addOnItems.length !== 0) {
              this.item.addOnItems.forEach(addon => {
                return addOnItemTime += addon.qty * addon.timeFactor
              })
            }
            let extraAddonTime = (addOnItemTime/60) - (item.includedHours - totalTravelHours)
            if (extraAddonTime > 0) {
              // let extraAddOnCost = extraAddonTime * item.costPerAdditionalUnit
              additionalTimelLineItem.qty = Number(extraAddonTime).toFixed(2)
              additionalTimelLineItem.cost = item.costPerAdditionalUnit
              lineItems.push(additionalTimelLineItem)
            }
            // console.log(+addOnItemTime/60)
            totalHours += +addOnItemTime/60
          }
          // product total calculations
          if(item.itemType === 'product') {
            // console.log('product')
            if (item.qty > 1) {
              total = item.baseRate + (item.qty - 1) * item.costPerAdditionalUnit
            } else {
              total = item.baseRate
            }
            // console.log(total)
          }
          //calculate additional hours cost
          if (totalHours > item.includedHours) {
            let additionalTime = totalHours - item.includedHours
            let additionalTimeCost = additionalTime * +item.costPerAdditionalUnit
            total += additionalTimeCost
          }
          let finalCost = total * item.additionalTimeFactor //editable to adjust total time qty per line item
          if (item.additionalCosts) {
            item.additionalCosts.forEach(cost => {
              lineItems.push(cost)
              return finalCost += cost.cost
            })
          }
          let totalEstimate = Number(finalCost).toFixed(2)
          this.totalEstimate = totalEstimate
          // this.updateLineItem()
          console.log('Distance: '+ totalKm)
          console.log('Time: '+ totalHours)
          console.log('Cost: '+ totalEstimate)
          },
        removeAddOnItem (addOnItemId) {
          // console.log(addOnItemId)
          let index = this.item.addOnItems.findIndex(addOn => {
            return addOn.id === addOnItemId
          })
          this.item.addOnItems.splice(index, 1)
          this.updateItem()
        },
        addOnItemPicked (item) {
          let newItem = {...item}
          newItem.qty = 1
          newItem.id = uuidv1()
          // console.log(item)
          this.item.addOnItems.push(item)
          // console.log(this.item)
          if (item.customAddOnItem) {
            this.selectedAddOnItem = item
            this.selectedAddOnItemDialog = true
          }
          this.updateItem()
        },
        updateAddOnItem () {
          // console.log(this.selectedAddOnItem)
          this.selectedAddOnItemDialog = false
          let filteredItem = this.item.addOnItems.find((filteredItem) => {
            return filteredItem.id === this.selectedAddOnItem.id
          })
          let filteredIndex = this.item.addOnItems.indexOf(filteredItem)
          this.item.addOnItems[filteredIndex] = this.selectedAddOnItem
          // console.log(this.item.addOnItems)
          this.updateItem()
        },
        modifyAddOnItem (selectedAddOnItem) {
          this.selectedAddOnItem = selectedAddOnItem
          this.selectedAddOnItemDialog= true
          // console.log(selectedAddOnItem)
        },
        openImgUploadDialog() {
          this.imageUploadDialog = true
        },
        addMoreCost () {
          let costObj = {...this.additionalCostObj}
          costObj.id = uuid()
          // console.log(this.item)
          this.item.additionalCost.push(costObj)
          // console.log(this.item.additionalCosts)
          this.addMoreCostDialog = false
          this.updateItem()
        },
        removeAdditionalCost (costObj) {
          // console.log(costObj)
          let index = this.item.additionalCost.indexOf(costObj)
          this.item.additionalCost.splice(index, 1)
          // console.log(index)
          this.updateItem()
        },
        updateItem () {
          this.productSettingsDialog = false
          let db = this.$store.state.db
          let publicListingItemRef = doc(db, 'publicListings', this.user.publicListingId, 'listings', this.listingId, 'items', this.itemId)
          let itemRef = doc(db, 'users', this.user.uid + '/listings/' + this.listingId + '/items/' + this.itemId)
          return updateDoc(itemRef, this.item)
              .then (() => {
                if (this.item.listed) {
                  let obj = {...this.item}
                  console.log(this.item)
                  return setDoc(publicListingItemRef, obj)
                } else {
                  let publicListingItemRef = doc(db, 'publicListings', this.user.publicListingId, 'listings', this.listingId, 'items', this.itemId)
                  return getDoc(publicListingItemRef)
                }
              })
              .then (res => {
                if(!this.item.listed) {
                  if (res.exists) {
                    deleteDoc(publicListingItemRef)
                  }
                }
              })
              .catch(err => {
                this.$store.dispatch('setError', err)
              })
          // console.log(this.item)
        },
        imageSelected (value) {
          this.pickedImage = this.item.imgs.find(img => {
            return img.id === value
          })
          this.selectedImageType = 'itemImgs'
          //console.log(this.pickedImage)
          this.imageDialog = true
        },
        deleteItem () {
          let db = this.$store.state.db
          let itemRef = doc(db, 'users', this.user.uid + '/listings/' + this.listingId + '/items/' + this.itemId)
          if (this.item.listed) {
            let publicListingItemRef = doc(db, 'publicListings', this.user.publicListingId, 'listings', this.listingId, 'items', this.itemId)
            return deleteDoc(publicListingItemRef)
                .then (() => {
                  return deleteDoc(itemRef)
                })
                .then (()=> {
                  this.$router.push('/listing/' + this.listingId)
                })
          } else {
            return deleteDoc(itemRef)
                .then (()=> {
                  this.$router.push('/listing/' + this.listingId)
                })
          }
        },
        deleteImage () {
          if(this.selectedImageType === 'featuredImg') {
            let index = this.item.featuredImgs.indexOf(this.pickedImage)
            this.item.featuredImgs.splice(index, 1)
          }
          if (this.selectedImageType === 'itemImgs') {
            let index = this.item.imgs.indexOf(this.pickedImage)
            this.item.imgs.splice(index, 1)
          }
          this.imageDialog = false
          this.updateItem()
          let userId = this.user.uid
          let storage = getStorage()
          let imgRef = ref(storage, '/users/' + userId + '/inventoryContent/' + this.pickedImage.id)
          deleteObject(imgRef).catch((err) => {
            console.log(err)
            this.$store.dispatch('setError', err)
          });
        },
        addImageLink (value) {
          this.mediaUrl = value.url
          this.imgId = value.id
        },
        uploadImgToItem () {
          this.item.imgs.push({
            id: this.imgId,
            url: this.mediaUrl
          })
          this.updateItem()
          this.imageUploadDialog = false
          this.mediaUrl = undefined
        },
        openFeaturedImage (value) {
          this.pickedImage = this.item.featuredImgs.find(img => {
            return img.id === value
          })
          this.selectedImageType = 'featuredImg'
          //console.log(this.pickedImage)
          this.imageDialog = true
        },
        addFeaturedImg () {
          this.item.featuredImgs.push({
            id: this.imgId,
            url: this.mediaUrl
          })
          this.updateItem()
          this.featuredImageUploadDialog = false
          this.mediaUrl = undefined
        },
        removeImageLink () {
          this.mediaUrl = undefined,
              this.imgId = ''
        },
        cancelImageUpload () {
          this.imageUploadDialog = false
          this.mediaUrl = undefined
          this.featuredImageUploadDialog = false
        },
        // in progress
        selectImgFromContent (link) {
          this.mediaUrl = link
          console.log(link)
        },
        saveImageUrl (link) {
          this.imageUrl = link
          this.addImageToCollection()
        },
        addImageToCollection () {
          // let contentRef = this.$store.state.db.collection('content')
          // contentRef.add({created: Date.now(), imageUrl: this.imageUrl, type: "image"})
          //     .then(() => {
          //       this.loadContent()
          //     })
          //     .catch(err => {
          //       this.$store.dispatch('setError', err)
          //     })
        }
      }
    }
</script>
